export class RepLogEntity{
    id:number;
    reportId:number;
    reportDate:string;
    personId:number;

    constructor(){}
}